var ButtonDropdown = require("components/utility/ButtonDropdown");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");

require("utility/inputs/toggle_multiselect.scss");

class ToggleMultiselect extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	
	forToggleOfType(type, key) {
		const config = this.props.toggles.find(x => {
			return (x.select || SELECT_LEFT_SHIFT_CLICK) === type;
		})
		
		if (config && key) {
			return config[key];
		} 
		return config;
	}
	
	onOptionClick(e, selectedKey) {
		let clickType;
		
		if (e.button === 0) {
			if (e.shiftKey) {
				clickType = SELECT_LEFT_SHIFT_CLICK
			} else {
				clickType = SELECT_LEFT_CLICK
			}
		}
		
		const toggleKey = this.forToggleOfType(clickType, "key");
		const isSingleton = !!this.forToggleOfType(clickType, "singleton");
		
		if (toggleKey) {
			let newSelected = {};
			
			if (!this.props.selected || this.props.selected[selectedKey] !== toggleKey) {
				
				// See if there's a key already set to the singleton case
				let previousSingletonKey
				if (isSingleton) {
					previousSingletonKey = _.findKey(this.props.selected, (x) => x === toggleKey);
				}
				
				// Update selection (if possible)
				newSelected = { ...this.props.selected, [selectedKey]: toggleKey };
				if (previousSingletonKey) {
					newSelected = _.omit(newSelected, previousSingletonKey);
				}
			} else {
				newSelected = _.omit(this.props.selected, selectedKey);
			}
			
			// Confirm the selection is valid (there's at exactly one of each singleton)
			let isValid = true;
			_.each(this.props.toggles, (config) => {
				if (config.singleton) {
					isValid = isValid && _.values(newSelected).filter(
						x => x === config.key
					).length === 1;
				}
			}) 
			
			if (isValid) {
				this.props.onChange(newSelected)				
			}
		}
	}
	
	displayText() {
		var primaryText;
		var otherTexts = [];
		
		_.each(this.props.toggles, (config) => {
			_.each(this.props.options, ({ key, text }) => {
				if (this.props.selected[key] === config.key) {
					if (config.primary) {
						primaryText = text;						
					} else {
						otherTexts.push(text);
					}
				}
			})
		})
		
		if (!primaryText) {
			primaryText = otherTexts.shift();
		}
		
		if (primaryText) {
			if (otherTexts.length) {
				return primaryText + " (+" + $wr.pluralizeWithNumber("other", otherTexts.length) + ")"
			} else {
				return primaryText;
			}
		} else if (this.props.defaultDisplayText) { 
			return this.props.defaultDisplayText
		} else {
			return "Select"
		}

	}

	render() {
		
		var className = "toggleMultiselect";
		if (this.props.className) {
			className += " " + this.props.className;
		}
		
		var options = this.props.options.map(x => {
			let icon;
			if (this.props.selected[x.key]) {
				const iconKey = _.findWhere(
					this.props.toggles, { key: this.props.selected[x.key] }
				).icon;
				if (this.props.selected[x.key] === 'primary' || this.props.selected[x.key] === 'secondary') {
					var iconDataTip = $wr.capitalize(this.props.selected[x.key]);
					icon = (
						<Glyphicon icon={iconKey} className="selectedIcon" dataTip={iconDataTip}/>
					)
				} else {
					icon = (
						<Glyphicon icon={iconKey} className="selectedIcon" />
					)
				}
			} else {
				icon = (
					<span className="selectedIconPlaceholder" />
				)				
			}
			return (
				<ButtonDropdownOption key={ x.key }
					onClick={ e => this.onOptionClick(e, x.key) }>
					
					{ icon } { x.text }
				</ButtonDropdownOption>
			)
		})
		
		if (this.props.topContent) {
			var topSection = (
				<div className="topContent">
					{ this.props.topContent }
				</div>
			)
		}
		
		return (
			<div className={ className }>
			
				<ButtonDropdown stickyOpen dropdownDisplay={ this.props.dropdownDisplay }
					text={ <span className="innerText">{ this.displayText()}</span> }>
					{ topSection }
					{ options }
				</ButtonDropdown>

			</div>
		)
	}
};

const SELECT_LEFT_CLICK = "select-left-click";
const SELECT_LEFT_SHIFT_CLICK = "select-left-shift-click";
// Could also do right click, alt click, etc.

ToggleMultiselect.SELECT_LEFT_CLICK = SELECT_LEFT_CLICK;
ToggleMultiselect.SELECT_LEFT_SHIFT_CLICK = SELECT_LEFT_SHIFT_CLICK;

ToggleMultiselect.propTypes = StrictPropTypes({
	dropdownDisplay: PropTypes.string,
	className: PropTypes.string,
	defaultDisplayText: PropTypes.string,
	
	topContent: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
		PropTypes.array
	]),
	
	// Object of option keys => toggle keys
	selected: PropTypes.object.isRequired,
	
	// Array of { key: "...", text: "..." }
	options: PropTypes.array.isRequired,
	
	// Array of { key: "...", icon: "...", text: "..." }
	//  optional: singleton (clears others with this type before selection; should always be one)
	//  optional: primary (affects displayText)
	//  optional: select (see SELECT options, left is LEFT)
	toggles: PropTypes.array.isRequired,
	
	// Function that gets passed a new version of the selected object
	onChange: PropTypes.func.isRequired
});

module.exports = ToggleMultiselect;




// WEBPACK FOOTER //
// ./modules/components/utility/inputs/ToggleMultiselect.js